type holdDescriptionType = {
  [key: string]: string
}
export const HOLD_DESCRIPTION: holdDescriptionType = {
  A: `We received notice that the check may be returned unpaid.
    If the check is not paid, we'll notify you by mail. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely from
    additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  B: `We have information that indicates the check may not be paid.
    If the check is not paid, we'll notify you by mail. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely from
    additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  C: `We have information that indicates the check may not be paid.
    If the check is not paid, we'll notify you by mail. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely
    from additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  D: `We are unable to verify the endorsement of a joint payee for the check.
    Please submit a signature card for the joint payee. If you need a signature card please contact
    customer service for assistance. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely
    from additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  E: `There is inconsistent information on the check you submitted.
    If the check is not paid, we'll notify you by mail. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely
    from additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  F: `The check you submitted appears to have been altered. If the check is not paid, we'll notify you by mail.
    If the check you deposited is paid, we will refund any fees for overdrafts
    or returned checks that result solely from additional delays imposed by us.
    To receive a refund of these type fees, please call 877-247-2559.
    We're available 24 hours a day, 7 days a week.`,

  G: `The bank routing number on the check you submitted is incorrect.
    If the check is not paid, we'll notify you by mail.
    If the check you deposited is paid, we will refund any fees for overdrafts
    or returned checks that result solely from additional delays imposed by us.
    To receive a refund of these type fees, please call 877-247-2559.
    We're available 24 hours a day, 7 days a week.`,

  H: `The check you submitted is postdated or expired. If the check is not paid, we'll notify you by mail.
    If the check you deposited is paid, we will refund any fees for overdrafts
    or returned checks that result solely from additional delays imposed by us.
    To receive a refund of these type fees, please call 877-247-2559.
    We're available 24 hours a day, 7 days a week.`,

  I: `The issuing bank let us know that the check may not be paid.
    If the check is not paid, we'll notify you by mail. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely
    from additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  J: `We have been notified that the check submitted has been lost or damaged in collection.
    If the check is not paid, we'll notify you by mail. If the check you deposited is paid,
    we will refund any fees for overdrafts or returned checks that result solely
    from additional delays imposed by us. To receive a refund of these type fees,
    please call 877-247-2559. We're available 24 hours a day, 7 days a week.`,

  L: 'The item deposited is over $5,000.',
  O: 'The account has repeated overdrafts.',
  X: 'The account has repeated overdrafts.',
  Y: 'The account is less than 30 days old.',
  Z: 'The item deposited is over $25,000.',
}

export const CD_FREQUENCY = {
  AtMaturity: 'At Maturity',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  SemiAnnually: 'Semi-Annually',
  Yearly: 'Annually (End of Year)',
  Annually: 'Annually (End of Year)',
}

export const DISBURSEMENT_METHODS = {
  RemainOnDeposit: 'Credit to the CD',
  PayByCheck: 'Send me a check',
  TransferToInternal: 'Deposit into another account',
  TransferToExternal: 'Deposit into another account',
  Custom: 'Custom',
}

export enum API_STATUS {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  REJECTED = 'REJECTED',
  UPDATING = 'UPDATING',
}

export const MAX_BUCKETS = 30
export const PREVIOUS_MAX_BUCKETS = 10

export const STK_CATEGORY_COLORS = {
  0: { name: 'Core Savings', colorName: '#C0D0D8' },
  1: { name: 'Emergencies', colorName: '#4DD0E1' },
  2: { name: 'Home', colorName: '#A1887F' },
  3: { name: 'Vacations', colorName: '#00ACC1' },
  4: { name: 'Occasions', colorName: '#FB8C00' },
  5: { name: 'Education', colorName: '#9575CD' },
  6: { name: 'Family', colorName: '#E57373' },
  7: { name: 'Tax payments', colorName: '#E65100' },
  8: { name: 'Bill payments', colorName: '#81C784' },
  9: { name: 'Vehicles', colorName: '#64B5F6' },
  10: { name: 'Pets', colorName: '#FFB74D' },
  11: { name: 'Make Your Own', colorName: '#43A047' },
  12: { name: 'Wedding', colorName: '#1E88E5' },
  13: { name: 'Retirement', colorName: '#6D4C41' },
}

export const TRANSFER_FREQUENCY = {
  1: 'Week', // 52 (transfers per year)
  2: '2 Weeks', // 26
  3: '15 Days', // 24
  4: '4 Weeks', // 13
  5: 'Month', // 12
  6: 'First business day of the month', // 12
  7: 'Last business day of the month', // 12
  8: '2 Months', // 6
  9: '3 Months', // 4
  10: '4 Months', // 3
  11: '6 Months', // 2
  12: 'Year', // 1
} as const

export const FREQUENCY_TRANSFERS_PER_YEAR = {
  1: 52,
  2: 26,
  3: 24,
  4: 13,
  5: 12,
  6: 12,
  7: 12,
  8: 6,
  9: 4,
  10: 3,
  11: 2,
  12: 1,
}

export const ACCOUNT_DETAILS_TAB_VALUES = [
  'activity',
  'spending',
  'buckets',
  'boosters',
]

export const TAB_VALUES_NUMBER = {
  activity: 0,
  spending: 1,
}

export const TAB_STK_DISTRIBUTE = {
  0: 'CHOOSE_TWO',
  1: 'CHOOSE_MULTIPLE',
}

export const TAB_STK_SETTINGS = {
  0: 'MONEY_OUT',
  1: 'MONEY_IN',
  2: 'INTEREST_PAID',
}

export const DEFAULT_MBOX_CONTENT = {
  content:
    "Prioritizing keeps you from stressing over not saving enough for all the things you want to do with your money. And if you've got a plan for saving towards multiple goals, it reduces the chance that something slips through the cracks.",
  template: 'insight',
}

export const DEFAULT_MBOX_CONTENT_PERFORMANCE = {
  content:
    "When your budget doesn't allow you to save as much as you like, start with a smaller savings goal. Any little bit you put away adds up.",
  template: 'insight',
}

export const PRODUCT_ID = {
  NOW_ACCOUNT_PREMIUM: 4003,
  NOW_ACCOUNT_BASIC: 4001,
  NOW_CMG_Account: 4800, // eslint-disable-line camelcase
  INTEREST_CHECKING: 4004,
  MONEY_MARKET_ONE: 4102,
  MONEY_MARKET_TWO: 4103,
  ONLINE_SAVINGS: 4107,
  HYSA_ONLINE_SAVINGS: 4108,
  IRA_ONLINE_SAVINGS: 3704,
  RYR_TWO_YEAR_CD: 3506,
  RYR_FOUR_YEAR_CD: 3508,
  IRA_RYR_CD: 3702,
  HIGH_YIELD_CDS: [3501, 3502, 3503, 3504, 3505, 3507, 3509, 3701],
  NO_PENALTY_CDS: [3512],
  RYR_CDS: [3506, 3508, 3702],
  SELECT_CDS: [3710, 3520],
}

export const RYR_GRACE_PERIOD = 10
export const DAY_LIMIT_FOR_BEST_RATE_GUARANTEE = 10
